import moment from "moment";

export const humanisetime = (t) => {
  const d = moment(t);
  if (d.year() === 1970 || t == null) {
    return "Never in 30 days";
  }
  return moment.duration(moment().diff(d)).humanize() + " ago";
};

export function formatTimeAgo(timestamp) {
  const currentTime = moment();
  const pastTime = moment(timestamp);
  const duration = moment.duration(currentTime.diff(pastTime));

  if (duration.asSeconds() < 60) {
    return `${Math.floor(duration.asSeconds())} seconds ago`;
  } else if (duration.asMinutes() < 60) {
    return `${Math.floor(duration.asMinutes())} minutes ago`;
  } else if (duration.asHours() < 24) {
    return `${Math.floor(duration.asHours())} hours ago`;
  } else if (duration.asDays() < 30) {
    return `${Math.floor(duration.asDays())} days ago`;
  } else if (duration.asMonths() < 12) {
    return `${Math.floor(duration.asMonths())} months ago`;
  } else {
    return `${Math.floor(duration.asYears())} years ago`;
  }
}

export function humaniseBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
